import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import ExploreIcon from '@mui/icons-material/Explore';

/**
 * Pantalla de carga inicial: se muestra hasta que datos e imágenes estén listos.
 */
export default function AppLoader() {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.paper',
        color: 'text.primary',
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress size={96} thickness={4} />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <ExploreIcon sx={{ fontSize: 52, color: 'primary.main' }} />
        </Box>
      </Box>
    </Box>
  );
}
